<span>
  {{
    '::GenAIFeatureUsage:Notification:TokenUsage:LimitReached'
      | abpLocalization: payloadData?.currentUsageCount : payloadData?.totalLimitCount
  }}
</span>
